/**
 * AdminWishlist.js — "My Wishlist" account dashboard page.
 *
 * Displays the logged-in user's saved wishlist items as product cards.
 * Wishlist is loaded from the engine API (if logged in) or localStorage (guest).
 * Allows removal from wishlist and add-to-cart actions.
 *
 * Props:
 *  - Good {string}                        Time-of-day greeting.
 *  - EngineURL {string}                   Base URL for the engine API.
 *  - useLoggedIn {boolean}                Whether the user is authenticated.
 *  - loggedInUserData {object}            Logged-in user details.
 *  - getAllWishlist {Array}               Current wishlist product slugs.
 *  - AddtoWishlist {Function}             Toggles a product in the wishlist.
 *  - Program_structure_images {Array}     Slug-to-image-URL mapping.
 *  - Program_structure_color {Array}      Slug-to-colour mapping.
 *  - UpdateCartQty {Function}             Updates the cart badge.
 *  - UpdateCartAmount {Function}          Updates the cart total.
 *  - AddtoCart {Function}                 Adds a product variant to the cart.
 *  - ShowLoginPopup {Function}            Opens the login modal.
 *  - ShowLoginPopup_ {Function}           Redirects to profile if logged in, else shows login.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import {
    Container,
    Row,
    Col
} from 'react-bootstrap';
import { Helmet } from "react-helmet";
import { AdminSidebar } from './Sidebar/AdminSidebar';
import axios from 'axios'
import { LoveItem } from './whishlist-item/item';
import { LoaderIcon } from '../../icons';

export const AdminWishlist = (props) => {

    const [userEmail, setUserEmail] = useState('');
    const [userToken, setUserToken] = useState(undefined);
    const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
    const location = useLocation();
    const routeLabels = {
      'admin-profile': 'My Profile',
      'admin-my-events': 'Upcoming Events',
      'admin-my-library': 'My Digital Library',
      'admin-cpd-points': 'CPD Points',
      'my-wishlist': 'Bookmarks',
      'admin-orders': 'Billing History',
    };
    const activeLabel = routeLabels[location.pathname.replace('/', '')] || 'Menu';


    useEffect(() => {
        if (props.loggedInUserData !== undefined && props.loggedInUserData !== null) {
            setUserEmail(props.loggedInUserData.email);
            setUserToken(props.loggedInUserData.accessToken);
        }
    }, [props.loggedInUserData]);





    /**
     * Do logout
     */
  const doLogout = () => {
    axios
      .post(props.EngineURL + "create-account/2fa/delete_2fa.php", {
        email: userEmail,
      },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`, // Replace `yourToken` with your actual token variable
          }
        })
      .then(function (response) {
        localStorage.removeItem("userDetail");
        localStorage.setItem("isLoggedin", false);
        localStorage.removeItem("checkout_token");
        localStorage.removeItem("thank_you_image");
        localStorage.removeItem("checkout_id");
        localStorage.removeItem("cart_session");
        localStorage.removeItem("create_account_detail");
        localStorage.removeItem("cart_session_sku");
        localStorage.removeItem("isLoggedin");
        localStorage.removeItem("was_book");
        localStorage.removeItem("wishlist_item");
        window.location.href = "/";
      })
      .catch(function (error) {
        console.log(error);
      });
  };






    return (
        <>   <div className="admin_page admin_cpd_points">
            <Helmet>
                <title>My Bookmarks | Leo Cussen Centre for Law</title>
            </Helmet>
            <Container>
                {
                    props.loggedInUserData !== undefined && props.useLoggedIn === true
                        ?

                        <div className="admin_wrapper position-relative">
                            {props.loggedInUserData !== null && props.loggedInUserData !== undefined ?
                                <div className='admin_details_block'>
                                    <p className="ae-greeting-text">{props.Good},</p>
                                    <h1 className="ae-greeting-name">{props.loggedInUserData.firstName}</h1>
                                </div>
                                : null}
                            <Row>
                                <Col xl={3} lg={4} xs={12} className="d-none d-lg-block">
                                    <AdminSidebar doLogout={doLogout} />
                                </Col>
                                <Col xl={9} lg={8} xs={12}>
                                    <div className="admin_right_content_block wishlist_right_block">
                                        <div className="admin_head">
                                            <h4 className="m-0">My Bookmarks</h4>
                                        </div>

                                        {props.wishlistLoading
                                            ? <div className="pre_loader"><LoaderIcon /></div>
                                            : props.getAllWishlist.length > 0
                                                ? (
                                                    <Row className="g-4">
                                                        {props.getAllWishlist.map((value, index) => (
                                                            <LoveItem
                                                                key={'ldo-' + index}
                                                                productHandle={value}
                                                                AddtoWishlist={props.AddtoWishlist}
                                                                getAllWishlist={props.getAllWishlist}
                                                                Program_structure_images={props.Program_structure_images}
                                                                AddtoCart={props.AddtoCart}
                                                            />
                                                        ))}
                                                    </Row>
                                                )
                                                : <div className="ae-no-events"><p>No records found</p></div>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        :
                        <>
                            <div className="text-center"><h3>Please login to access My profile section</h3><button onClick={() => props.ShowLoginPopup_()} className="btn btn-primary rounded-pill m-0 stest"> Login</button></div>
                        </>
                }
            </Container>
        </div>
        <div className={`admin_sidebar_mobile${mobileSidebarOpen ? ' sidebar-open' : ''}`}>
            <div className="admin_sidebar_drawer">
                <AdminSidebar doLogout={doLogout} />
            </div>
            <button
                className="admin_sidebar_trigger"
                onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}
                aria-expanded={mobileSidebarOpen}
            >
                <span className="admin_sidebar_trigger_label">{activeLabel}</span>
                <svg className="admin_sidebar_trigger_dots" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="5" r="1.5" fill="#1C1C1C"/>
                    <circle cx="12" cy="12" r="1.5" fill="#1C1C1C"/>
                    <circle cx="12" cy="19" r="1.5" fill="#1C1C1C"/>
                </svg>
            </button>
        </div>

        </>
    );
}